export default __webpack_public_path__ + "static/media/M5 - Wounded Bear.9bc6a6fb.png";